/* unplugin-vue-components disabled */import script from "./ManagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePage.vue?vue&type=script&setup=true&lang=js"

import "./ManagePage.vue?vue&type=style&index=0&id=17c7f692&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c7f692"]])

export default __exports__